import { PartComponent } from "../models/part-component";

export class PartComponentMapper {
    // Maps a part component API response to a {@link PartComponent}.
    // @param partComponentResponse The API part component to convert.
    // @returns The mapped {@link PartComponent}.
    public static mapPartComponent(partComponentResponse: any) {
        return new PartComponent(partComponentResponse.componentName,
                                 partComponentResponse.coverageGroup,
                                 partComponentResponse.componentCode)
    }
}